import { Component, Input, SimpleChanges } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ComplementoFaturaCteComponent } from "../complemento-fatura-cte.component";
import { ComplementoFaturaCteModel } from "../complemento-fatura-cte.model";

@Component({
  selector: "app-complemento-fatura-cte-grid-pesquisa",
  templateUrl: "./complemento-fatura-cte-grid-pesquisa.component.html",
  styleUrls: ["./complemento-fatura-cte-grid-pesquisa.component.scss"],
})
export class ComplementoFaturaCteGridPesquisaComponent {
  public grid: MatTableDataSource<ComplementoFaturaCteModel> =
    new MatTableDataSource<ComplementoFaturaCteModel>();
  @Input() parent: ComplementoFaturaCteComponent;
  @Input() gridData;

  get exibirGrid() {
    return this.parent.exibirGrid;
  }
  set exibirGrid(value) {
    this.parent.exibirGrid = value;
  }

  get isLoading() {
    return this.parent.isLoading;
  }
  set isLoading(value) {
    this.parent.isLoading = value;
  }

  get isLoadingDownload() {
    return this.parent.isLoadingDownload;
  }
  set isLoadingDownload(value) {
    this.parent.isLoadingDownload = value;
  }

  get paging() {
    return this.parent.paging;
  }
  set paging(value) {
    this.parent.paging = value;
  }

  constructor(public router: Router) {
    this.grid.data = this.gridData;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.grid.data = changes["gridData"].currentValue;
  }

  public displayedColumns: string[] = [
    "action",
    "faturaLoteId",
    "usuario",
    "clienteNome",
    "tipoFaturaDescricao",
    "dataInclusao",
    "statusDescricao"
  ];

  limparPesquisa() {
    this.grid.data = null;
    this.exibirGrid = false;
    this.isLoading = false;
  }
}
